import React from 'react';
import ConsultantTicketListTable from './ConsultantTicketListTable';
import { connect } from 'react-redux';
import Card from 'react-bootstrap/Card';
import { consultantTicketListFetch, consultantTicketListSetPage, consultantTicketListUnload } from '../../lib/redux/actions/consultantTickets';
import Alert from 'react-bootstrap/Alert';
import Paginator from '../../components/common/Paginator';
import * as ROUTES from '../../lib/routing/frontend';
import MASpinner from '../../components/common/MASpinner';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ConsultantTicketTableFilterForm from '../../components/forms/ConsultantTicket/ConsultantTicketTableFilterForm';
import { isClient } from '../../lib/helper/authorisation';
import CONSULTANT_TICKET_TYPE_CODES from '../../lib/helper/consultantTicketTypeCodes';

// paginationRoute: the frontend route used when paginating (defaults to ALL_TICKETS)
// suppressDefaultTypeFilter: when true, skip injecting the non-broadcast type code filter
//   (used by the broadcast list which already receives a type filter via defaultFilters prop)

const mapStateToProps = (state) => ({
  ...state.consultantTickets,
});

const mapDispatchToProps = {
  consultantTicketListFetch,
  consultantTicketListSetPage,
  consultantTicketListUnload,
};

class ConsultantTicketListContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showFilters: false,
      initialFilterDone: false,
      sort: { field: 'actionDate', dir: 'asc' },
    };
  }

  getCombinedFilters() {
    const { filters, defaultFilters = {}, initialFilterVals = {}, suppressDefaultTypeFilter = false } = this.props;
    const { sort } = this.state;
    if (!suppressDefaultTypeFilter && !isClient()) {
      defaultFilters['consultantTicketType.code'] = [
        CONSULTANT_TICKET_TYPE_CODES.BANK_CHANGE,
        CONSULTANT_TICKET_TYPE_CODES.FEE_CHANGE,
        CONSULTANT_TICKET_TYPE_CODES.HOLIDAY,
        CONSULTANT_TICKET_TYPE_CODES.OTHER,
        CONSULTANT_TICKET_TYPE_CODES.FEE_CONFIRMATION,
        CONSULTANT_TICKET_TYPE_CODES.INSURANCE_RECOGNITION,
        CONSULTANT_TICKET_TYPE_CODES.LEAVING,
        CONSULTANT_TICKET_TYPE_CODES.PATIENT_QUERY,
        CONSULTANT_TICKET_TYPE_CODES.MONTHLY_REPORT_QUERY,
      ];
    }
    const orderParam = { [`order[${sort.field}]`]: sort.dir };
    if ( this.state.initialFilterDone === false ) {
      this.setState({initialFilterDone: true});
      return { ...initialFilterVals, ...defaultFilters, ...filters, ...orderParam };
    }
    return { ...defaultFilters, ...filters, ...orderParam };
  }

  handleSortChange(field) {
    this.setState((prevState) => ({
      sort: {
        field,
        dir: prevState.sort.field === field && prevState.sort.dir === 'asc' ? 'desc' : 'asc',
      },
    }));
  }

  componentDidMount() {
    this.props.consultantTicketListFetch(this.getQueryParamPage(), this.getCombinedFilters());
  }

  componentWillUnmount() {
    this.props.consultantTicketListUnload();
  }

  componentDidUpdate(prevProps, prevState) {
    const { currentPage, consultantTicketListFetch, consultantTicketListSetPage, filters } = this.props;

    if (prevProps?.match && prevProps.match.params.page !== this.getQueryParamPage()) {
      consultantTicketListSetPage(this.getQueryParamPage());
    }
    if (prevProps.currentPage !== currentPage || prevProps.filters !== filters || prevState.sort !== this.state.sort) {
      consultantTicketListFetch(currentPage, this.getCombinedFilters());
    }
  }

  getQueryParamPage() {
    return this.props?.match?.params?.page ? Number(this.props.match.params.page) : 1;
  }

  changePage(page) {
    const { history, consultantTicketListSetPage, pushToHistory = true, paginationRoute = ROUTES.CONSULTANT_TICKETS.ALL_TICKETS } = this.props;
    consultantTicketListSetPage(page);
    if (pushToHistory) {
      history.push(paginationRoute.replace(':page', page));
    }
  }

  nextPage() {
    const { currentPage, pageCount } = this.props;
    const newPage = Math.min(currentPage + 1, pageCount);
    this.changePage(newPage);
  }

  prevPage() {
    const { currentPage } = this.props;
    const newPage = Math.max(currentPage - 1, 1);
    this.changePage(newPage);
  }

  toggleFilters() {
    this.setState((prevState) => {
      return { showFilters: !prevState.showFilters };
    });
  }

  render() {
    const { consultantTickets, isFetchingConsultantTickets, currentPage, pageCount, pageTitle, totalItems = 0, consultant = false, showTypeFilter = false } = this.props;
    return (
      <div>
        <Card className={`${consultant !== false ? 'no-shadow' : ''}`}>
          <Card.Header>
            <div className="d-flex justify-content-between">
              {' '}
              {pageTitle}
              <div>
                <button className="btn btn-sm btn-outline-secondary mr-3" onClick={this.toggleFilters.bind(this)}>
                  Filters
                </button>
                {!isFetchingConsultantTickets && consultantTickets && consultantTickets.length > 0 && (
                  <span className="tabular-data-result-count">{pageCount} pages / {totalItems} Tickets</span>
                )}
              </div>
            </div>
          </Card.Header>

          {this.state.showFilters && (
            <Card.Body className={'mediaccount-filter-wrapper'}>
              <ConsultantTicketTableFilterForm consultant={consultant} showTypeFilter={showTypeFilter} />
            </Card.Body>
          )}

          {isFetchingConsultantTickets && (
            <Card.Body>
              <MASpinner />
            </Card.Body>
          )}

          {!isFetchingConsultantTickets && (consultantTickets === null || consultantTickets.length === 0) && (
            <Card.Body>
              <Alert variant={'info'} className="mb-0">
                No tickets found
              </Alert>
            </Card.Body>
          )}
          {!isFetchingConsultantTickets && consultantTickets && consultantTickets.length > 0 && (
            <Row>
              <Col sm={12}>
                <Row>
                  <Col>
                    <ConsultantTicketListTable
                  consultantTickets={consultantTickets}
                  sortField={this.state.sort.field}
                  sortDir={this.state.sort.dir}
                  onSortChange={this.handleSortChange.bind(this)}
                />
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
          {!isFetchingConsultantTickets && consultantTickets && consultantTickets.length > 0 && (
            <Paginator
              currentPage={currentPage}
              pageCount={pageCount}
              setPage={this.changePage.bind(this)}
              nextPage={this.nextPage.bind(this)}
              prevPage={this.prevPage.bind(this)}
            />
          )}
        </Card>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConsultantTicketListContainer);
